import { c as _c } from "react/compiler-runtime";
import { ProjectModel } from '@/models/organizations/internal-models';
import { usePagination } from '@/comps/pagination';
import { AggregateVariable, GetInteractionAggregatesReq, type GetInteractionAggregatesReqFiltersItem, GetInteractionAggregatesReqGroupBy, GroupByConversationCustomAggregateKind, GroupByConversationCustomColumnKind, GroupByCustomAggregateKind, GroupByCustomColumnKind, GroupByTagKind, QueryOrdering, TimeRangeConfig } from '@/api/generated/model';
import { useMemo } from 'react';
import { useFetchInteractionAggregates } from '@/models/interaction-aggregates/useFetchInteractionAggregates';
import { AggregateBy } from '@/domains/dashboard/components/GlobalfiltersRow';
import { splitFilters } from '@/utils/filter-utils';
export const groupByToFilter = (groupBy: GetInteractionAggregatesReqGroupBy): string | undefined => {
  if (!groupBy.kind) return;
  if (groupBy.kind === GroupByTagKind.tag) {
    return `tag:${groupBy.tag}`;
  }
  if (groupBy.kind === GroupByCustomAggregateKind.custom_aggregate) {
    return `custom_aggregate:${groupBy.custom_aggregate}`;
  }
  if (groupBy.kind === GroupByConversationCustomAggregateKind.conversation_custom_aggregate) {
    return `conversation_custom_aggregate:${groupBy.custom_aggregate}`;
  }
  if (groupBy.kind === GroupByCustomColumnKind.custom_column) {
    return `custom_column:${groupBy.custom_column}`;
  }
  if (groupBy.kind === GroupByConversationCustomColumnKind.conversation_custom_column) {
    return `conversation_custom_column:${groupBy.custom_column}`;
  }
  return groupBy.kind;
};
type FetchAggregatesFilters = {
  search?: string;
  aggregatesGroupBy: GetInteractionAggregatesReqGroupBy | undefined;
  aggregateBy: AggregateBy;
  timeRange: TimeRangeConfig;
  mergedFilters: GetInteractionAggregatesReqFiltersItem[];
  penetrationVariable?: string;
};
export function useFetchAggregates(t0) {
  const $ = _c(36);
  const {
    selectedProject,
    pag,
    sortBy,
    filters,
    variables,
    aggregateBy,
    calculatePrevious
  } = t0;
  const {
    search,
    aggregatesGroupBy,
    timeRange,
    mergedFilters,
    penetrationVariable
  } = filters;
  selectedProject?.id;
  let specialFilters;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== aggregatesGroupBy || $[1] !== mergedFilters || $[2] !== pag.offset || $[3] !== pag.pageSize || $[4] !== search || $[5] !== selectedProject?.id) {
    const {
      regularFilters,
      specialFilters: t6
    } = splitFilters(mergedFilters);
    specialFilters = t6;
    t1 = aggregatesGroupBy;
    t2 = selectedProject?.id;
    t3 = pag.pageSize;
    t4 = pag.offset;
    let t7;
    if ($[12] !== aggregatesGroupBy || $[13] !== search) {
      t7 = aggregatesGroupBy?.kind ? [{
        column: groupByToFilter(aggregatesGroupBy),
        values: [],
        search
      }] : [];
      $[12] = aggregatesGroupBy;
      $[13] = search;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    t5 = [...regularFilters, ...t7];
    $[0] = aggregatesGroupBy;
    $[1] = mergedFilters;
    $[2] = pag.offset;
    $[3] = pag.pageSize;
    $[4] = search;
    $[5] = selectedProject?.id;
    $[6] = specialFilters;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    specialFilters = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
  }
  const t6 = specialFilters as any;
  let t7;
  if ($[15] !== variables) {
    t7 = [...variables];
    $[15] = variables;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== calculatePrevious || $[18] !== penetrationVariable || $[19] !== sortBy || $[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== timeRange) {
    t8 = {
      group_by: t1,
      project_id: t2,
      limit: t3,
      offset: t4,
      filters: t5,
      special_filters: t6,
      time_range: timeRange,
      variables: t7,
      order_by: sortBy,
      penetration_variable: penetrationVariable,
      calculate_previous: calculatePrevious
    };
    $[17] = calculatePrevious;
    $[18] = penetrationVariable;
    $[19] = sortBy;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = timeRange;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  const aggregatesPayload = t8 as GetInteractionAggregatesReq;
  let t9;
  if ($[29] !== aggregateBy || $[30] !== aggregatesPayload) {
    t9 = {
      payload: aggregatesPayload,
      aggregateBy
    };
    $[29] = aggregateBy;
    $[30] = aggregatesPayload;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  const {
    data: aggregatesData,
    isLoading: isAggregatesLoading
  } = useFetchInteractionAggregates(t9);
  let t10;
  if ($[32] !== aggregatesData || $[33] !== aggregatesPayload || $[34] !== isAggregatesLoading) {
    t10 = {
      aggregatesData,
      isAggregatesLoading,
      aggregatesPayload
    };
    $[32] = aggregatesData;
    $[33] = aggregatesPayload;
    $[34] = isAggregatesLoading;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  return t10;
}